import { ChatWindow } from "@/pages/Messaging/ChatWindow/types";
import React from "react";
export const ChatWindowsContext = React.createContext<{
  chatWindows: ChatWindow[];
  loading: boolean;
  createChatWindow: (name: string) => Promise<ChatWindow | undefined>;
  saving: boolean;
  deleteChatWindow: (id: number) => Promise<void>;
  getChatWindowById: (id: number) => Promise<ChatWindow | undefined>;
}>({
  chatWindows: [],
  loading: false,
  createChatWindow: async () => undefined,
  saving: false,
  deleteChatWindow: async () => {},
  getChatWindowById: () => Promise.resolve(undefined)
});
